/**
 * useResponsiveTables — Batch #14.289 (mobile) : sur petit écran, chaque tableau du conteneur devient une pile de cartes.
 * Les libellés de colonnes (thead > th) sont recopiés dans `data-label` de chaque cellule (CSS `.rt-table` dans index.css).
 * Opt-out par tableau : `<table data-rt="off">`.
 */
import { useEffect } from "react";

function labelCells(table) {
  if (table.dataset.rt === "off") return;
  table.classList.add("rt-table");
  const headRow = table.tHead?.rows?.[table.tHead.rows.length - 1];
  const labels = [];
  if (headRow) {
    for (const th of headRow.cells) {
      const txt = (th.innerText || th.textContent || "").replace(/\s+/g, " ").trim();
      for (let i = 0; i < (th.colSpan || 1); i++) labels.push(txt);
    }
  }
  const bodies = [...table.tBodies, ...(table.tFoot ? [table.tFoot] : [])];
  for (const body of bodies) {
    for (const row of body.rows) {
      let col = 0;
      for (const td of row.cells) {
        const label = labels[col] || "";
        if (td.dataset.label !== label) td.dataset.label = label;
        if ((td.colSpan || 1) > 1) td.classList.add("rt-full");
        col += td.colSpan || 1;
      }
    }
  }
}

export function useResponsiveTables(ref) {
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    let scheduled = false;
    const run = () => {
      scheduled = false;
      root.querySelectorAll("table").forEach(labelCells);
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(run);
    };
    run();
    const obs = new MutationObserver(schedule);
    obs.observe(root, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, [ref]);
}
